module.exports = __webpack_public_path__ + "img/two_lines-svg-new.5618476b.svg";